import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ComFutSearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getCommFutSearch(data);
    }
}
export default ComFutSearchUseCase;
